/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { fg } from '@atlassian/jira-feature-gating';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { WorkforceOptimizationExperimentPageQuery as WorkforceOptimizationExperimentPageQueryDefinition } from './__generated__/WorkforceOptimizationExperimentPageQuery.graphql';
import workforceOptimizationExperimentPageQueryParameters from './__generated__/WorkforceOptimizationExperimentPageQuery$parameters.ts';

type WorkforceOptimizationEntryPointComponent = EntryPointComponent<
	{
		teamCountsQuery?: WorkforceOptimizationExperimentPageQueryDefinition;
	},
	{},
	{},
	{ cloudId: string; orgId?: string; projectKey: string }
>;

export const workforceOptimizationEntryPoint: EntryPoint<
	WorkforceOptimizationEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<WorkforceOptimizationEntryPointComponent>(
		/* webpackChunkName: "async-servicedesk-workforce-optimization", jiraSpaEntry: "async-servicedesk-workforce-optimization" */ './WorkforceOptimizationPage.tsx',
	),
	getPreloadProps: ({
		context: { match },
		tenantContext: { cloudId, orgId },
	}: EntryPointRouteParams) => {
		const projectKey = match.params.projectKey ?? '';
		const organizationId = orgId ? `ari:cloud:platform::org/${orgId}` : undefined;

		return {
			queries:
				organizationId && fg('wfm_simplified_onboarding')
					? {
							teamCountsQuery: {
								options: {
									fetchPolicy: 'store-or-network' as const,
								},
								parameters: workforceOptimizationExperimentPageQueryParameters,
								variables: {
									filter: null,
									organizationId,
									showEmptyTeams: fg('uat-875-fix-onboarding-bugs') ? true : null,
									siteId: cloudId,
								},
							},
						}
					: {},
			extraProps: { cloudId, orgId, projectKey },
		};
	},
});
